import { omit } from 'lodash'

import { EditSchema } from '../../../schemas/editSchema'
import { Variables } from './types'

export const mapper = (data: EditSchema): Variables => {
  return {
    ...omit(data, 'domainId'),
  }
}
